import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getAppPrefix } from "./../../EmbedChannels/utility/embedHelper";
import ProfileIcon from "../../../assets/icons/profile.svg";
import { useSelector } from "react-redux";
import ColorProfile from "../../../assets/images/color_profile.svg";
import EmptyChatIcon from "../../../assets/icons/empty_chat.svg";
import { useDispatch } from "react-redux";
import { fetchInboxMessages } from "./../../../redux/slices/dmSlice";

const fmtTime = (d) => {
  if (!d) return "";
  try {
    const date = new Date(d);
    const now = new Date();
    const sameDay = date.toDateString() === now.toDateString();
    return sameDay
      ? date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })
      : date.toLocaleDateString([], { day: "numeric", month: "short" });
  } catch (e) {
    return "";
  }
};

const Avatar = ({ user }) => {
  if (user?.logo)
    return (
      <img
        src={user.logo}
        alt=""
        className="h-11 w-11 flex-shrink-0 rounded-full object-cover"
        loading="lazy"
      />
    );
  if (user?.color_logo)
    return (
      <div
        className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-full"
        style={{ backgroundColor: user.color_logo }}
      >
        <img src={ColorProfile} alt="" className="h-6 w-6" />
      </div>
    );
  return (
    <img
      src={ProfileIcon}
      alt=""
      className="h-11 w-11 flex-shrink-0 rounded-full object-cover"
    />
  );
};

const DMMessages = () => {
  const chats = useSelector((state) => state.dmChat.messages);
  const loading = useSelector((state) => state.dmChat.loading);
  const { username } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(fetchInboxMessages());
  }, [dispatch]);

  const openChat = (chat) =>
    navigate(
      `${getAppPrefix()}/user/${username}/messages/list/${chat.otherUser.username}`
    );

  if (loading && chats.length === 0) {
    return (
      <div className="flex h-full w-full items-center justify-center text-sm text-theme-placeholder">
        Loading…
      </div>
    );
  }

  if (chats.length === 0) {
    return (
      <div className="mx-auto flex h-full w-3/4 flex-col items-center justify-center pb-10 text-center">
        <img src={EmptyChatIcon} alt="" className="h-24 opacity-80" />
        <p className="mt-3 text-sm font-medium text-theme-secondaryText">
          No conversations yet
        </p>
        <p className="mt-1 text-xs text-theme-placeholder">
          Open a member's profile and tap Message to start a chat.
        </p>
      </div>
    );
  }

  return (
    <div className="flex h-full w-full flex-col overflow-y-auto custom-scrollbar">
      {chats.map((chat) => {
        const lm = chat.lastMessage || {};
        const preview = lm.content
          ? `${lm.fromMe ? "You: " : ""}${lm.content}`
          : lm.hasMedia
          ? "Attachment"
          : "";
        const unread = chat.unread || 0;
        return (
          <button
            key={chat._id}
            onClick={() => openChat(chat)}
            className="flex w-full items-center gap-3 border-b border-theme-chatDivider/50 px-4 py-3 text-left transition-colors hover:bg-theme-tertiaryBackground"
          >
            <Avatar user={chat.otherUser} />
            <div className="min-w-0 flex-1">
              <div className="flex items-center justify-between gap-2">
                <span
                  className={`truncate text-sm ${
                    unread > 0
                      ? "font-semibold text-theme-secondaryText"
                      : "font-medium text-theme-secondaryText"
                  }`}
                >
                  {chat.otherUser?.name || chat.otherUser?.username}
                </span>
                <span className="flex-shrink-0 text-[11px] text-theme-placeholder">
                  {fmtTime(lm.createdAt)}
                </span>
              </div>
              <div className="mt-0.5 flex items-center justify-between gap-2">
                <span
                  className={`truncate text-xs ${
                    unread > 0
                      ? "text-theme-secondaryText"
                      : "text-theme-placeholder"
                  }`}
                >
                  {preview || `@${chat.otherUser?.username}`}
                </span>
                {unread > 0 && (
                  <span className="flex h-5 min-w-[20px] flex-shrink-0 items-center justify-center rounded-full bg-theme-accent px-1.5 text-[11px] font-semibold text-theme-accentText">
                    {unread}
                  </span>
                )}
              </div>
            </div>
          </button>
        );
      })}
    </div>
  );
};

export default DMMessages;
